/**
 * postForm does a cross domain form/urlencoded post
*/
export default function postForm (uri, vals) {
  const body = document.body

  const form = document.createElement('form')
  form.method = 'POST'
  form.action = uri

  for (let key in vals) {
    const i = document.createElement('input')
    i.type = 'hidden'
    i.name = key
    i.value = vals[key]
    form.appendChild(i)
  }

  body.appendChild(form)
  form.submit()
  body.removeChild(form)
}



// WEBPACK FOOTER //
// ./modules/utils/postForm.js